import React from 'react';
import ViewAdminSchedules from '../ViewAdminSchedules';

const ScheduleByPreceptorPage = () => <ViewAdminSchedules scheduleType="preceptor" />;

export default ScheduleByPreceptorPage;
